import { state as base_state } from "../../dynamicDDL/store/state";

export function state() {
	return base_state();
}
